
import NavItem from '../nav-link';

export default ({ data, industry, cdn }) => {
    let { name, slug } = data;

    slug = '/companies/' + slug;

    const industryType = industry?.name || 'No industry set'
    let image = null;

    const sections  = data?.company_profile?.page?.sections;

    if(sections) {
        const heroIndex = _.findIndex(sections, item => item.name === 'hero');
        if(heroIndex !== -1) {
            if(sections[heroIndex].content.hasOwnProperty('background')) {
               image = sections[heroIndex].content['background'].value;
            }
        }
    }

    const onClick = () => {
       window.location.href = slug;
    }

    return (
        <div class="index-item" style={{ backgroundImage: `url(${ image ? cdn + '/images/' + image : '/images/blocks/index/item-image.svg' })`}} onClick={onClick}>
            <div class="index-item__cover"></div>
            <div class="index-item__content">
                <NavItem slug={slug} color="green" text="Discover" />
                {
                    data?.company_profile?.profile?.logo &&
                    <img className="index-item__logo" src={data?.company_profile?.profile?.logo ? cdn + '/images/' + data.company_profile.profile?.logo : ""} />

                }
                <div class="index-item__bottom">
                    <b>{ name }</b>
                    <p>{ industryType }</p>
                </div>
            </div>
        </div>
    )
}
